import { connect } from 'react-redux'
import { getHederTextArr } from '../../../../utils/langaugeSupport'
import ProgramHeader from '../../../ReusableComponents/Header/ProgramHeader'
import style from './GraphUi.module.css'
import { useRef, useState } from 'react'
import Footer from './Footer'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    BarChart,
    Bar,
    ResponsiveContainer,
} from 'recharts'
import renderPrgImage from '../../../../source/programImg'
import Sidebar from './SideBar'
import DialogModal from '../../../ReusableComponents/DialogModal/DialogModal'
import GraphGeneration from './GraphGeneration'
// const defaultDatas = [
//     {
//         pv: '',
//         uv: 0,
//         mic: 0,
//         temp: 0,
//         batt: 0,
//         touch0: 0,
//         touch2: 0,
//         touch3: 0,
//         acceX: 0,
//         acceY: 0,
//         acceZ: 0,
//         gyroX: 0,
//         gyroY: 0,
//         gyroZ: 0,
//         ultrasonic: 0,
//         red: 0,
//         green: 0,
//         blue: 0,
//         // distance: 0,
//         proximity: 0,
//         light: 0,
//         gesture: 0,
//         switch1: 0,
//         switch2: 0,
//         A1: 0,
//         A2: 0,
//         B1: 0,
//         B2: 0,
//         C1: 0,
//         C2: 0,
//         D1: 0,
//         D2: 0,
//         E1: 0,
//         E2: 0,
//         F1: 0,
//         F2: 0,
//     },
// ]
const defaultDatas = [
    { name: 'A', uv: 400, pv: 2400 },
    { name: 'B', uv: 300, pv: 1398 },
    { name: 'C', uv: 200, pv: 9800 },
    { name: 'D', uv: 278, pv: 3908 },
]
function GraphUi(props) {
    // const [datas, setDatas] = useState(defaultDatas)
    // const [graphType, setGraphType] = useState('line')
    // const [showSidebar, setShowSidebar] = useState(true)
    const [isPaPlay, setIsPaPlay] = useState(false)
    const [isShowTimeInput, setIsShowTimeInput] = useState(false)

    const [isSidebarOpen, setIsSidebarOpen] = useState(true)

    const stopFuntionRef = useRef(null)
    const setDatasRef = useRef(null)
    const chartRef = useRef(null)
    const datasRef = useRef([])

    //handel time input submit
    const handleSubmit = (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const data = Object.fromEntries(formData.entries())

        const totalMilliseconds =
            Number(data.hours) * 3600000 +
            Number(data.minutes) * 60000 +
            Number(data.seconds) * 1000 +
            Number(data.milliseconds)
        if (totalMilliseconds < 100) {
            return
        }

        props.graphPlotStorage({
            time: {
                h: Number(data.hours),
                m: Number(data.minutes),
                s: Number(data.seconds),
                ms: Number(data.milliseconds),
            },
        })
        setIsShowTimeInput(false)
    }

    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev)
    }
    const languageName = props.indexData.device.language

    return (
        <div className={style.container}>
            {/*----- open the model to take the time input ------*/}
            <DialogModal
                show={isShowTimeInput}
                // text={'showDeviceConnectModal.text'}
                styles={{ width: '500px' }}
                showCloseBtn={true}
                handleDialogModalClose={() => setIsShowTimeInput(false)}
            >
                <div className={style['parent-container']}>
                    <form
                        onSubmit={handleSubmit}
                        className={style['time-form']}
                    >
                        {/* Labels Row */}
                        <div className={style['label-row']}>
                            <label>Hours</label>
                            <label>Minutes</label>
                            <label>Seconds</label>
                            <label>Milliseconds</label>
                        </div>

                        {/* Input Row with colons */}
                        <div className={style['input-row']}>
                            <input
                                type="number"
                                name="hours"
                                defaultValue={props.time.h}
                                min="0"
                                max="23"
                            />
                            <span className={style['colon']}>:</span>

                            <input
                                type="number"
                                name="minutes"
                                defaultValue={props.time.m}
                                min="0"
                                max="59"
                            />
                            <span className={style['colon']}>:</span>

                            <input
                                type="number"
                                name="seconds"
                                defaultValue={props.time.s}
                                min="0"
                                max="59"
                            />
                            <span className={style['colon']}>:</span>

                            <input
                                type="number"
                                name="milliseconds"
                                defaultValue={props.time.ms}
                                min="0"
                                max="999"
                            />
                        </div>

                        <div className={style['submit-container']}>
                            <button
                                className={style['timeSubmit']}
                                type="submit"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </DialogModal>
            <ProgramHeader
                data={{
                    options: getHederTextArr({
                        languageName,
                        keyArr: ['SelectSensors', 'SelectPorts', 'Plot'],
                    }),
                    selected: 4,
                }}
                showSave={true}
                showHelp={false}
                graph={true}
                chartRef={chartRef}
                // handleHelp={helpBtn}
            />

            {/* body of the graph */}
            {/* <div className={style.body}>
                <div
                    className={`${style.sidebar} ${
                        showSidebar ? style.sidebarVisible : style.sidebarHidden
                    }`}
                >
                    {showSidebar && (
                        <button
                            onClick={toggleSidebar}
                            className={style.toggleBtn}
                        >
                            <img
                                src={renderPrgImage('backBtn')}
                                alt="Hide Sidebar"
                                style={{ transform: 'rotate(180deg)' }}
                            />
                        </button>
                    )}
                    {showSidebar && (
                        <p style={{ padding: '1rem' }}>Sidebar Content</p>
                    )}
                </div>

                {!showSidebar && (
                    <button
                        onClick={toggleSidebar}
                        className={style.sidebarHiddenBtn}
                    >
                        <img
                            src={renderPrgImage('backBtn')}
                            alt="Show Sidebar"
                        />
                    </button>
                )}

                <div
                    className={`${style.graphArea} ${
                        showSidebar ? style.withSidebar : style.fullWidth
                    }`}
                >
                    <div className={style.graphWrapper}>
                        <ResponsiveContainer width="100%" height="100%">
                            {graphType === 'line' ? (
                                <LineChart data={datas}>
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <CartesianGrid
                                        stroke="#eee"
                                        strokeDasharray="5 5"
                                    />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#8884d8"
                                    />
                                </LineChart>
                            ) : (
                                <BarChart data={datas}>
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <CartesianGrid stroke="#ccc" />
                                    <Bar dataKey="pv" fill="#82ca9d" />
                                </BarChart>
                            )}
                        </ResponsiveContainer>
                    </div>
                </div>
            </div> */}

            <div className={style.body}>
                {/* Sidebar */}
                <div
                    className={`${style.sidebar} ${
                        isSidebarOpen ? style.open : style.closed
                    }`}
                >
                    {isSidebarOpen && (
                        // <div className={style.sidebarContent}>Sidebar</div>
                        <Sidebar stopFuntionRef={stopFuntionRef} />
                    )}
                </div>

                {/* Toggle Button (outside sidebar so it's always visible) */}
                <button
                    className={`${style.toggleBtn} ${
                        isSidebarOpen ? style.sidebarOpen : style.sidebarClosed
                    }`}
                    onClick={toggleSidebar}
                >
                    <img
                        src={renderPrgImage('sideBarOpenArrow')}
                        alt="arrow button"
                    />
                    {/* {isSidebarOpen ? '<' : '>'} */}
                </button>

                {/* Main Content */}
                <div
                    className={`${style.mainBody} ${
                        isSidebarOpen ? style.shrink : style.expand
                    }`}
                >
                    {/* <div className={style.graphWrapper}>
                        <ResponsiveContainer width="100%" height="100%">
                            {graphType === 'line' ? (
                                <LineChart data={datas}>
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <CartesianGrid
                                        stroke="#eee"
                                        strokeDasharray="5 5"
                                    />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="uv"
                                        stroke="#8884d8"
                                    />
                                </LineChart>
                            ) : (
                                <BarChart data={datas}>
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <CartesianGrid stroke="#ccc" />
                                    <Bar dataKey="pv" fill="#82ca9d" />
                                </BarChart>
                            )}
                        </ResponsiveContainer>
                    </div> */}

                    <GraphGeneration
                        isPaPlay={isPaPlay}
                        setIsPaPlay={setIsPaPlay}
                        stopFuntionRef={stopFuntionRef}
                        setDatasRef={setDatasRef}
                        chartRef={chartRef}
                    />
                </div>
            </div>
            <Footer
                setIsShowTimeInput={setIsShowTimeInput}
                isPaPlay={isPaPlay}
                setIsPaPlay={setIsPaPlay}
                stopFuntionRef={stopFuntionRef}
                setDatasRef={setDatasRef}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        indexData: state,
        worker: state.worker,
        time: state.graphPlotStorage.time,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        graphPlotStorage: (data) => {
            dispatch({ type: 'GRAPH_PLOTSTORAGE', payload: data })
        },
        DeselectedComponent: (data) => {
            dispatch({ type: 'GRAPH_PLOTSTORAGE', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GraphUi)
